/**
 * @description: 打开修改计划定向弹窗
 * @param {*} rowIndex // 单条修改时的行索引
 * @return {*}
 */
export function onTargetModify(rowIndex) {
  // 点击单行时设置check状态
  if (!Object.is(Number(rowIndex), NaN)) {
    this.tableData = this.tableData.map((row, index) => {
      return { ...row, targetCheck: index === rowIndex }
    })
  } else {
    if (!this.tableData.some((row) => row.targetCheck)) {
      return this.$Message.warning('请选择修改行')
    }
  }

  this.modal.showGlobalTargetModify = true
}

/**
 * @description: 更换账号确认
 * @return {*}
 */
export function onTargetModifyConfirm(targetItem) {
  if (targetItem) {
    const plan = this.tableData.find((row) => row.target.name === targetItem.name)

    this.tableData = this.tableData.map((row) => {
      if (row.targetCheck) {
        const newRow = { ...row, target: { ...targetItem } }
        // 腾讯广告v3, 修改定向时，会重新分组，需要更新当前计划的名称
        if (this.pageStates.isV3 && plan) {
          newRow.plan.project_name = plan.plan.project_name
        }
        return newRow
      }
      return row
    })
  }

  this.onModifyModalCancel()
}
